/* this file is transformed by vux-loader */
/* eslint-disable */
import _typeof from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.split.js";
var hasOwnProperty = Object.prototype.hasOwnProperty;
var camelizeRE = /-(\w)/g;
export function camelize(str) {
  return str.replace(camelizeRE, function (_, c) {
    return c.toUpperCase();
  });
}
export function isDef(value) {
  return value !== undefined && value !== null;
}
export function isObj(x) {
  var type = _typeof(x);

  return x !== null && (type === "object" || type === "function");
}

function assignKey(to, from, key) {
  var val = from[key];

  if (!isDef(val)) {
    return;
  }

  if (!hasOwnProperty.call(to, key) || !isObj(val) || typeof val === "function") {
    to[key] = val;
  } else {
    // eslint-disable-next-line no-use-before-define
    to[key] = deepAssign(Object(to[key]), from[key]);
  }
}

export function deepAssign(to, from) {
  Object.keys(from).forEach(function (key) {
    assignKey(to, from, key);
  });
  return to;
}
export function get(object, path) {
  var keys = path.split(".");
  var result = object;
  keys.forEach(function (key) {
    result = isDef(result[key]) ? result[key] : "";
  });
  return result;
}